// extracted by mini-css-extract-plugin
export default {"main":"Connections_main__5cLnM","loadingState":"Connections_loadingState__itsPx","list":"Connections_list__n0dtl"};